import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

import t from '../../shared/translations';
import Archived from './Archived';
import Inbox from './Inbox';
import NavBar from './NavBar';
import SendButton from './SendButton';
import Sent from './Sent';

const Wrapper = styled.div`
    border: 1px solid lightgray;
    padding: 5px;
    min-height: 300px;
    flex-grow: 1;
    @media (min-width: 400px) {
        padding: 10px;
    }
    @media (min-width: 600px) {
        padding: 15px;
    }
`;

const Header = styled.header`
    display: flex;
    flex-direction: column;
    @media (min-width: 600px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const H1 = styled.h1`
    text-align: center;
    @media (min-width: 600px) {
        text-align: left;
    }
`;

function Messages(): JSX.Element {
    return <Wrapper>
        <Header>
            <H1>{t('player.messages.heading')}</H1>
            <SendButton />
        </Header>
        <NavBar />
        <Routes>
            <Route path='inbox' element={<Inbox />} />
            <Route path='archived' element={<Archived />} />
            <Route path='sent' element={<Sent />} />
            <Route path='/' element={<Navigate to='inbox' />} />
        </Routes>
    </Wrapper>;
}

export default Messages;
